import type { Styles } from 'react-joyride'
import { palettePrimaryMain } from '@/theme/designTokens'


/** Tooltip shell — Figma Tour 7 (`4154:4476`) uses `bg-[var(--white,white)]`; aligns with Dev Handoff tooltip frames. */
const FTUX_TOOLTIP_SURFACE = '#ffffff'

/**
 * FTUX tooltip chrome — Figma Dev Handoff (`4154:4366`–`4154:4475`).
 * Body `#4c5357`, step badge `#a2b1ba`, primary `palettePrimaryMain`, radius 10px, shadow as spec.
 */
export const sensemakerFtuxJoyrideStyles: Partial<Styles> = {
  /**
   * AppShell scrolls inside `<main overflow:auto>`, not the document. Joyride’s default
   * absolute overlay + document-height SVG can leave the spotlight cutout offset from the
   * target (seen on “Create New Campaign”). Pin the mask to the viewport so cutout coords
   * from `getBoundingClientRect()` stay aligned.
   */
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    position: 'fixed',
    inset: 0,
    width: '100%',
    height: '100%',
    maxHeight: '100%',
  },
  /** Joyride auto-focuses the beacon button on first step — suppress default browser focus ring. */
  beaconWrapper: {
    outline: 'none',
    border: 'none',
    boxShadow: 'none',
  },
  beacon: {
    outline: 'none',
  },
  /** Drop shadow lives on `tooltip`; remove Joyride’s default floater filter so the card isn’t double-glowed. */
  floater: {
    filter: 'none',
  },
  tooltip: {
    borderRadius: '10px',
    padding: 0,
    overflow: 'hidden',
    boxShadow: '0px 25px 50px rgba(0, 0, 0, 0.25)',
    backgroundColor: FTUX_TOOLTIP_SURFACE,
    minWidth: 320,
    maxWidth: 360,
  },
  /**
   * Footer is a sibling of this div in react-joyride (not a child). Bottom spacing before the
   * footer row is `tooltipFooter.marginTop` (Figma `gap-[16px]`); bottom inset is `tooltipFooter`
   * padding — do not add paddingBottom here or the body↔footer gap becomes 24px instead of 16px.
   */
  tooltipContainer: {
    padding: '24px',
    paddingBottom: 0,
    textAlign: 'left',
    backgroundColor: FTUX_TOOLTIP_SURFACE,
  },
  tooltipTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: '#04183f',
    letterSpacing: '-0.4395px',
    lineHeight: '28px',
    margin: 0,
    marginBottom: 0,
    width: '100%',
  },
  tooltipContent: {
    color: '#4c5357',
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '-0.1504px',
    paddingTop: 12,
    marginTop: 0,
  },
  tooltipFooter: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 16,
    minHeight: 36,
    paddingLeft: 24,
    paddingRight: 24,
    paddingBottom: 24,
  },
  /** Skip sits in this flex row; keep control aligned with Figma footer (`4155:5338`). */
  tooltipFooterSpacer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
    minHeight: 36,
  },
  buttonPrimary: {
    backgroundColor: palettePrimaryMain,
    borderRadius: 8,
    color: '#ffffff',
    fontSize: 14,
    fontWeight: 500,
    padding: '10px 16px',
    outline: 'none',
    border: 'none',
    letterSpacing: '-0.1504px',
  },
  buttonSkip: {
    color: '#64748b',
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: '-0.1504px',
    lineHeight: '20px',
    padding: 0,
    margin: 0,
    borderRadius: 0,
    border: 'none',
    backgroundColor: 'transparent',
  },
}
